(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('unfaced-country-selector')) {
    customElements.define('unfaced-country-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.uf-country-trigger');
        let previousOverflow;
        const close = () => dialog.close();
        trigger.addEventListener('click', () => {
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          trigger.setAttribute('aria-expanded', 'true');
          this.querySelector('select').focus();
        });
        this.querySelector('.uf-country-close').addEventListener('click', close);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = previousOverflow || '';
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        });
      }
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unfaced-global-style"]) return;
  try {
    
  (() => {
    const storageKey = 'unfaced-favorites-v1';

    const readFavorites = () => {
      try {
        const stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(stored) ? stored.filter((item) => item && item.id) : [];
      } catch (error) {
        return [];
      }
    };

    const writeFavorites = (favorites) => {
      window.localStorage.setItem(storageKey, JSON.stringify(favorites));
    };

    const updateButtons = () => {
      const favoriteIds = new Set(readFavorites().map((item) => String(item.id)));
      document.querySelectorAll('[data-favorite-toggle]').forEach((button) => {
        const isActive = favoriteIds.has(String(button.dataset.productId));
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive.toString());
        button.setAttribute('aria-label', isActive ? button.dataset.removeLabel : button.dataset.addLabel);
      });
    };

    const renderFavoritesPage = () => {
      const page = document.querySelector('[data-favorites-page]');
      if (!page) return;

      const favorites = readFavorites();
      const grid = page.querySelector('[data-favorites-grid]');
      const empty = page.querySelector('[data-favorites-empty]');
      const template = page.querySelector('[data-favorites-card-template]');
      grid.replaceChildren();
      empty.hidden = favorites.length > 0;

      favorites.forEach((item) => {
        const card = template.content.cloneNode(true);
        const link = card.querySelector('[data-favorite-link]');
        const image = card.querySelector('[data-favorite-image]');
        const title = card.querySelector('[data-favorite-title]');
        const price = card.querySelector('[data-favorite-price]');
        const button = card.querySelector('[data-favorite-toggle]');

        link.href = item.url;
        title.textContent = item.title;
        price.textContent = item.price;
        if (item.image) {
          image.src = item.image;
          image.alt = item.title;
        } else {
          image.hidden = true;
        }

        button.dataset.productId = item.id;
        button.dataset.productTitle = item.title;
        button.dataset.productUrl = item.url;
        button.dataset.productImage = item.image || '';
        button.dataset.productPrice = item.price;
        button.dataset.addLabel = page.dataset.addLabel;
        button.dataset.removeLabel = page.dataset.removeLabel;
        button.setAttribute('aria-label', page.dataset.removeLabel);
        grid.appendChild(card);
      });
    };

    const synchronizeFavorites = () => {
      updateButtons();
      renderFavoritesPage();
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-favorite-toggle]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const id = String(button.dataset.productId || '');
      if (!id) return;

      const favorites = readFavorites();
      const existingIndex = favorites.findIndex((item) => String(item.id) === id);
      if (existingIndex >= 0) {
        favorites.splice(existingIndex, 1);
      } else {
        favorites.unshift({
          id,
          title: button.dataset.productTitle || '',
          url: button.dataset.productUrl || '',
          image: button.dataset.productImage || '',
          price: button.dataset.productPrice || '',
        });
      }

      writeFavorites(favorites);
      synchronizeFavorites();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', synchronizeFavorites, { once: true });
    } else {
      synchronizeFavorites();
    }

    document.addEventListener('shopify:section:load', synchronizeFavorites);
    window.addEventListener('storage', synchronizeFavorites);
  })();

  } catch(e) { console.error(e); }
})();
})();
